<script lang="ts">
  import { onDestroy } from "svelte";
  import BoxIcon from "../../components/atoms/BoxIcon.svelte";
  import Card from "../../components/atoms/Card.svelte";
  import Heading from "../../components/atoms/Heading.svelte";
  import HouseIcon from "../../components/atoms/HouseIcon.svelte";
  import Link from "../../components/atoms/Link.svelte";
  import Text from "../../components/atoms/Text.svelte";
  import CustomContent from "../../components/molecules/CustomContent.svelte";

  interface Props {
    content?: string;
    headerContent?: string;
    campaign: string;
    setIsMovingFlow: (value: boolean) => void;
    microCampaignUrl: string | undefined;
  }

  let {
    content = undefined,
    headerContent = undefined,
    campaign,
    setIsMovingFlow,
    microCampaignUrl,
  }: Props = $props();

  onDestroy(() => {
    setIsInitialScreenUnmounted();
  });

  const setIsInitialScreenUnmounted = () => {
    const event = new Event("initialScreenUnmounted");
    window.dispatchEvent(event);
  };
</script>

{#if headerContent}
  <CustomContent content={headerContent} />
{/if}
<Card>
  <Heading margin={false} variant={"primary"} class="text-PurplePrimary"
    >Se ditt elpris och teckna elavtal</Heading
  >
  <div class="flex space-x-3 mt-6">
    <HouseIcon class="text-PurplePrimary my-auto" />
    <div class="py-2.5">
      <Link arrowPosition="left" class="font-bold" onClick={() => setIsMovingFlow(false)}>
        Teckna elavtal
      </Link>
      <Text variant="primary" class="mt-0.5">
        För dig som vill teckna elavtal där du bor eller för t.ex ett fritidshus.
      </Text>
    </div>
  </div>
  <div class="flex space-x-3 mt-8">
    <BoxIcon class="text-PurplePrimary my-auto" />
    <div class="py-2.5">
      <Link arrowPosition="left" class="font-bold" onClick={() => setIsMovingFlow(true)}
        >Teckna elavtal dit du ska flytta</Link
      >
      <Text variant="primary" class="mt-0.5">
        För dig som ska flytta och vill teckna elavtal för din nya adress.
      </Text>
    </div>
  </div>
  {#if !campaign}
    <div class="mt-8">
      <Text variant="primary"
        >Redan kund? På <a class="text-Violet900" href="https://minasidor.skekraft.se/">
          Mina sidor</a
        >
        tecknar du enkelt, snabbt och bekvämt nytt elavtal.
        <br /><a class="text-Violet900" href="https://minasidor.skekraft.se/"
          >Logga in på Mina sidor</a
        >
      </Text>
    </div>
  {/if}
  {#if campaign && microCampaignUrl}
    <div class="mt-6">
      <Link href={microCampaignUrl}>Teckna elavtal med mikroproduktion</Link>
    </div>
  {/if}
</Card>
{#if content}
  <CustomContent {content} />
{/if}
